/* eslint-disable @next/next/no-img-element */
import { scrollBar } from 'shared/components/mixins';
import styled from 'styled-components';

type Customer = {
  img: string;
  alt: string;
};

const CUSTOMERS: Customer[] = [
  {
    img: '/img/logos/dark/modivo.png',
    alt: 'Modivo',
  },
  {
    img: '/img/logos/dark/gomez.png',
    alt: 'Gomez',
  },
  {
    img: '/img/logos/dark/neonail.png',
    alt: 'Neonail',
  },
  {
    img: '/img/logos/dark/wittchen.png',
    alt: 'Wittchen',
  },
  {
    img: '/img/logos/dark/rylko.png',
    alt: 'Ryłko',
  },
  {
    img: '/img/logos/dark/victoriasSecret.png',
    alt: "Vicoria's Secret",
  },
  {
    img: '/img/logos/dark/super-pharm.png',
    alt: 'Super-Pharm',
  },
];

function LogosInLine(): JSX.Element {
  return (
    <LogosWrapper>
      <Logos>
        {CUSTOMERS.map((customer) => (
          <img key={customer.alt} src={customer.img} alt={customer.alt} />
        ))}
      </Logos>
    </LogosWrapper>
  );
}

const LogosWrapper = styled.section`
  padding: 1.6rem;
  margin-top: -10rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  position: relative;

  @media ${({ theme }) => theme.DEVICE.MD} {
    padding: 10rem 1.6rem 5.6em 1.6rem;
  }
`;

const Logos = styled.div`
  display: flex;
  align-items: start;
  justify-content: start;
  overflow-y: auto;
  gap: 1.6em;
  margin: 0 auto;
  ${scrollBar};
  padding-bottom: 0.4em;
  scrollbar-width: thin;
`;

export default LogosInLine;
